import type { MailboxInfo } from 'owa-client-types';
import { updateAccountScopeUserSettingsAndService } from 'owa-userconfiguration/lib/utils/updateAccountScopeUserSettingsAndService';
import setIsFocusedInboxCapableService from '../services/setIsFocusedCapableService';
import { getStateAndCreateIfUndefined } from './mutatorUtils';
import { saveFocusInboxEnable } from './saveFocusInboxEnable';
import selectFocusedInboxOptionMutator from './selectFocusedInboxOption';

export default function saveFocusedInboxOption(
    mailboxInfo: MailboxInfo,
    isEnabledOverride?: boolean
): Promise<any[]> {
    if (isEnabledOverride !== undefined) {
        selectFocusedInboxOptionMutator(isEnabledOverride, mailboxInfo);
    }

    const optionState = getStateAndCreateIfUndefined(mailboxInfo);
    const servicePromises: Promise<any>[] = [];
    servicePromises.push(
        updateAccountScopeUserSettingsAndService(mailboxInfo, {
            UserOptions: {
                IsFocusedInboxEnabled: !!optionState.isEnabled,
            },
        })
    );
    // Raise action so that, if we're running in mail, the focused inbox will toggle on and off
    // Do this later to use config update so the code that depends on user config reads the
    // updated value
    saveFocusInboxEnable(optionState.isEnabled, mailboxInfo);

    // Make a request to set IsFocusedInboxCapable if IsFocusedInboxEnabled is set to true
    if (optionState.isEnabled) {
        servicePromises.push(setIsFocusedInboxCapableService(mailboxInfo));
    }
    return Promise.all(servicePromises);
}
